import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "space-info"
};
var _hoisted_2 = {
  class: "space-info-body"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  key: 1,
  class: "feature_box-top"
};
var _hoisted_5 = {
  style: {
    "width": "70px"
  }
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  key: 0,
  class: "dropdown"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "eyes-container"
};
var _hoisted_10 = {
  class: "eyes id-div"
};
var _hoisted_11 = {
  key: 0
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  key: 0,
  class: "eyes-menu"
};
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
  class: "second-div"
};
var _hoisted_16 = {
  class: "left-div"
};
var _hoisted_17 = {
  class: "avatar-div"
};
var _hoisted_18 = ["src"];
var _hoisted_19 = {
  class: "info-div"
};
var _hoisted_20 = {
  class: "name-stars"
};
var _hoisted_21 = {
  class: "name-div"
};
var _hoisted_22 = {
  key: 0,
  class: "rank-name"
};
var _hoisted_23 = {
  key: 0,
  class: "level-info"
};
var _hoisted_24 = {
  class: "argin-r8"
};
var _hoisted_25 = {
  class: "level-progress"
};
var _hoisted_26 = {
  class: "margin-r8"
};
var _hoisted_27 = {
  class: "level-point"
};
var _hoisted_28 = {
  key: 0,
  class: "class-info"
};
var _hoisted_29 = {
  class: "honor-div"
};
var _hoisted_30 = {
  class: "line-div"
};
var _hoisted_31 = {
  class: /*@__PURE__*/_normalizeClass({
    'nav-tab': true
  })
};
var _hoisted_32 = {
  class: "left-tab"
};
var _hoisted_33 = ["onClick"];
var _hoisted_34 = {
  class: "tab-span"
};
var _hoisted_35 = {
  class: /*@__PURE__*/_normalizeClass({
    'page-content': true
  })
};
import { reactive, ref, markRaw, onMounted, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
/** 组件 */
import navLeft from '@/components/navLeft';
import HomePage from './home/index.vue';
import ActivityPage from './activity/index.vue';
// import PhotoPage from './photo/index.vue'
import LessonPage from './lesson/index.vue';
import NotePage from './note/index.vue';
import BgImageDialog from '../spaceInfo/home/ImageDialog.vue';
import RateLevel from './RateLevel.vue';
/** 工具 */
import { getStore } from '@/util/store';
import { MessagePlugin } from 'tdesign-vue-next';
import defaultAvatar from '@/assets/icons/defaultAvatar.svg';
/** api */
import { getUserSpaceBaseInfo, settingRadius, addVisitorLog } from '@/api/spaceInfo.js';
import { isTeacher, isStudent } from '@/hooks/useGoOtherSpace.js';
import { useTaskApi } from '@/hooks/useTaskApi';
import WujieVue from 'wujie-vue3';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var _route$query;
    var _useTaskApi = useTaskApi(),
      fetchUserTypeSchoolList = _useTaskApi.fetchUserTypeSchoolList,
      fetchCurrentSemesterBySchoolId = _useTaskApi.fetchCurrentSemesterBySchoolId,
      fetchLevelRankDetail = _useTaskApi.fetchLevelRankDetail;
    var bus = WujieVue.bus;
    var route = useRoute();
    var router = useRouter();
    var userId = route.query.userId;
    var isFullSpacePage = ((_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.hideLeftBar) === 'false' ? false : true; // 是否全屏无左侧菜单页
    var accessInfo = getStore({
      name: 'accessInfo'
    }); // 获取accessInfo
    var userInfo = getStore({
      name: 'userInfo'
    });
    var curUserId = ref(userId || (accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.user_id)); // 当前用户id

    var visitorType = ref(1); // 0:游客 1:自己(自己访问自己空间仍为个人视角)  2:公开

    var tabs = reactive([{
      name: '首页',
      component: markRaw(HomePage),
      icon: 'home_space'
    }, {
      name: '活动',
      component: markRaw(ActivityPage),
      icon: 'activity_space'
    }
    // {
    //     name: '相册',
    //     component: PhotoPage,
    //     icon: 'icon-pic_fill'
    // },
    // {
    //     name: '课堂互动',
    //     component: markRaw(LessonPage),
    //     icon: 'icon-computer_fill'
    // },
    // {
    //     name: '笔记',
    //     component: markRaw(NotePage),
    //   icon: 'icon-a-13'
    // }
    ]);
    var activeTab = ref(0); // 当前激活的tab
    var infoData = ref({}); // 基础信息数据

    // 公开范围
    var isDropdownOpen = ref(false);
    var options = ref([{
      content: '全部',
      value: '0'
    }, {
      content: '最近一个月',
      value: '1'
    }, {
      content: '本学期',
      value: '2'
    }, {
      content: '本学年',
      value: '3'
    }]);
    //  视角
    var optionsVisual = ref([{
      content: '我自己',
      value: 1
    }, {
      content: '公开',
      value: 2
    }]);
    var clickLeftValue = ref();
    var viewingAngle = ref(optionsVisual.value[0].content);
    // 切换公开范围
    var clickLeft = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              isDropdownOpen.value = false;
              clickLeftValue.value = val.content;
              _context.p = 1;
              _context.n = 2;
              return settingRadius(curUserId.value, val.value);
            case 2:
              _context.n = 3;
              return getBaseInfo();
            case 3:
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              MessagePlugin.error('操作失败');
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 4]]);
      }));
      return function clickLeft(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    // 切换视角
    var isEyesDownOpen = ref(false);
    var clickRight = function clickRight(val) {
      isEyesDownOpen.value = false;
      visitorType.value = val.value;
      viewingAngle.value = val.content;
    };

    // 切换背景图
    var showBgImageDialog = ref(false);
    var handleMoreClick = function handleMoreClick() {
      showBgImageDialog.value = true;
    };
    /** 初始化相关 */
    var getBaseInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var id,
          res,
          _ref3,
          code,
          data,
          msg,
          _options$value$find,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              id = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : curUserId.value;
              _context2.p = 1;
              _context2.n = 2;
              return getUserSpaceBaseInfo(id);
            case 2:
              res = _context2.v;
              _ref3 = res.data || {}, code = _ref3.code, data = _ref3.data, msg = _ref3.msg;
              if (code === 0) {
                infoData.value = data || {};
                if ((accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.user_id) !== infoData.value.id) visitorType.value = 0;
                clickLeftValue.value = (_options$value$find = options.value.find(function (item) {
                  return item.value === infoData.value.radius;
                })) === null || _options$value$find === void 0 ? void 0 : _options$value$find.content;
              } else {
                // 后端业务校验未通过（如该账号不是学生账号），原样提示后端返回的原因，避免页面空白无反馈
                MessagePlugin.warning(msg || '获取用户空间信息失败');
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              MessagePlugin.error('获取用户空间信息失败');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }));
      return function getBaseInfo() {
        return _ref2.apply(this, arguments);
      };
    }();

    /** 事件相关 */
    // 返回
    var goBack = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!isTeacher()) {
                _context3.n = 1;
                break;
              }
              // 教师个人主页
              router.push("/spaceInfo?userId=".concat(userInfo.id));
              _context3.n = 3;
              break;
            case 1:
              if (!isStudent()) {
                _context3.n = 3;
                break;
              }
              // 学生个人主页
              viewingAngle.value = optionsVisual.value[0].content;
              _context3.n = 2;
              return getBaseInfo(accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.user_id);
            case 2:
              visitorType.value = 1;
              curUserId.value = accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.user_id;
              _context3.n = 3;
              return updateUserInfo(accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.user_id);
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function goBack() {
        return _ref4.apply(this, arguments);
      };
    }();
    // 复制ID
    var copyId = function copyId(id) {
      var text = document.createElement('textarea');
      text.value = id;
      document.body.appendChild(text);
      text.select();
      document.execCommand('copy');
      MessagePlugin.success('复制成功');
      text.remove();
    };

    // 前往个人信息页
    var goUserInfo = function goUserInfo(allowJump) {
      if (visitorType.value === 0) return; // 游客视角，不允许跳转
      if (allowJump) {
        router.push('/userInfo');
      }
    };

    // 切换tab
    var changeActiveTab = function changeActiveTab(index) {
      activeTab.value = index;
    };
    /**
     * 游客模式
     * @param val id 用户ID
     * @param num 0:游客 1:自己 2:公开
     * @param userType  类型 0:学生，1：老师
     */
    var changeId = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(id, num, userType) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              console.log('changeId', id, num, userType);
              _context4.n = 1;
              return addVisitorLog(id, {
                visitorAvatar: userInfo.avatar
              });
            case 1:
              if (!(userType === '0')) {
                _context4.n = 3;
                break;
              }
              visitorType.value = num;
              curUserId.value = id;
              //查看主页对象是学生 学生看学生主页
              getBaseInfo(id);
              _context4.n = 2;
              return updateUserInfo(id);
            case 2:
              _context4.n = 4;
              break;
            case 3:
              // 老师个人主页
              router.push("/spaceInfo?userId=".concat(id));
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function changeId(_x2, _x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }();

    // 等级段位等信息
    var schoolList = ref([]);
    var schoolId = ref('');
    var semesterInfo = ref({});
    var levelInfo = ref({});
    // 定义更新用户信息的函数
    var updateUserInfo = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(userId) {
        var _schoolList$value$, _semesterInfo$value;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return fetchUserTypeSchoolList(userId, 2);
            case 1:
              schoolList.value = _context5.v;
              schoolId.value = ((_schoolList$value$ = schoolList.value[0]) === null || _schoolList$value$ === void 0 ? void 0 : _schoolList$value$.schoolId) || '';
              if (!schoolId.value) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return fetchCurrentSemesterBySchoolId(schoolId.value);
            case 2:
              semesterInfo.value = _context5.v;
            case 3:
              if (!((_semesterInfo$value = semesterInfo.value) !== null && _semesterInfo$value !== void 0 && _semesterInfo$value.id)) {
                _context5.n = 5;
                break;
              }
              _context5.n = 4;
              return fetchLevelRankDetail({
                userId: userId,
                semesterId: semesterInfo.value.id,
                currentSemesterFlag: 1
              });
            case 4:
              levelInfo.value = _context5.v;
            case 5:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      return function updateUserInfo(_x5) {
        return _ref6.apply(this, arguments);
      };
    }();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var _route$query2, userId, hideLeftBar;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            _route$query2 = route.query, userId = _route$query2.userId, hideLeftBar = _route$query2.hideLeftBar;
            if (hideLeftBar && hideLeftBar === 'false') {
              addVisitorLog(userId, {
                visitorAvatar: userInfo.avatar
              });
            }
            getBaseInfo(); // 获取用户空间基本信息
            bus.$on('refreshSpacePage', function () {
              visitorType.value = 1;
              curUserId.value = accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.user_id;
              getBaseInfo(accessInfo === null || accessInfo === void 0 ? void 0 : accessInfo.user_id);
            });
            _context6.n = 1;
            return updateUserInfo(userId || userInfo.id);
          case 1:
            return _context6.a(2);
        }
      }, _callee6);
    })));
    onUnmounted(function () {
      bus.$off('refreshSpacePage');
    });
    return function (_ctx, _cache) {
      var _levelInfo$value, _levelInfo$value2, _levelInfo$value3, _levelInfo$value4, _levelInfo$value5, _levelInfo$value6, _levelInfo$value7, _levelInfo$value8, _infoData$value$class, _infoData$value$certi, _infoData$value$certi2, _infoData$value$certi3, _infoData$value$class2, _infoData$value$certi4, _infoData$value$class3;
      var _component_t_progress = _resolveComponent("t-progress");
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_unref(navLeft), null, null, 512), [[_vShow, !_unref(isFullSpacePage)]]), _createElementVNode("div", _hoisted_2, [_createElementVNode("header", {
        class: "header",
        style: _normalizeStyle("background: white url(".concat(infoData.value.backgroundImage, ") no-repeat scroll center/cover;"))
      }, [_createElementVNode("div", {
        class: _normalizeClass([visitorType.value === 2 ? 'feature_eyes' : 'feature_box'])
      }, [visitorType.value === 0 && !_unref(isFullSpacePage) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: goBack
      }, [_createElementVNode("img", {
        src: require('@/assets/home/backHome.svg'),
        alt: ""
      }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), visitorType.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", {
        class: "text",
        style: {
          "width": "250px"
        },
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return isDropdownOpen.value = !isDropdownOpen.value;
        })
      }, [_cache[7] || (_cache[7] = _createTextVNode(" 公开展示的时间范围： ", -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(clickLeftValue.value), 1), _createElementVNode("img", {
        src: require('@/assets/home/chevron-down.svg'),
        alt: ""
      }, null, 8, _hoisted_6)]), isDropdownOpen.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, function (option) {
        return _openBlock(), _createElementBlock("div", {
          key: option.value,
          class: _normalizeClass(["dropdown-item", {
            'dropdown-item-active': option.content === clickLeftValue.value
          }]),
          onClick: function onClick($event) {
            return clickLeft(option);
          }
        }, _toDisplayString(option.content), 11, _hoisted_8);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "text base-img",
        onClick: handleMoreClick
      }, "换背景图")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, "主页ID: " + _toDisplayString(infoData.value.spaceAccount), 1), _createElementVNode("span", {
        class: "copy-span",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return copyId(infoData.value.spaceAccount);
        })
      }, "复制")]), visitorType.value !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", {
        class: "eyes",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return isEyesDownOpen.value = !isEyesDownOpen.value;
        })
      }, [_createTextVNode(" 视角：" + _toDisplayString(viewingAngle.value) + " ", 1), _createElementVNode("img", {
        src: require('@/assets/home/chevron-down.svg'),
        alt: ""
      }, null, 8, _hoisted_12)]), isEyesDownOpen.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsVisual.value, function (option) {
        return _openBlock(), _createElementBlock("div", {
          key: option.value,
          class: _normalizeClass(["eyes-item", {
            'eyes-item-active': option.content === viewingAngle.value
          }]),
          onClick: function onClick($event) {
            return clickRight(option);
          }
        }, _toDisplayString(option.content), 11, _hoisted_14);
      }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])], 2), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
        src: infoData.value.avatar || _unref(defaultAvatar),
        alt: "",
        class: "avatar-img",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return goUserInfo(true);
        })
      }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(infoData.value.name), 1), _createVNode(RateLevel, {
        stars: infoData.value.qualityScore
      }, null, 8, ["stars"]), (_levelInfo$value = levelInfo.value) !== null && _levelInfo$value !== void 0 && (_levelInfo$value = _levelInfo$value.studentRankInfo) !== null && _levelInfo$value !== void 0 && _levelInfo$value.currentRankName ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString((_levelInfo$value2 = levelInfo.value) === null || _levelInfo$value2 === void 0 || (_levelInfo$value2 = _levelInfo$value2.studentRankInfo) === null || _levelInfo$value2 === void 0 ? void 0 : _levelInfo$value2.currentRankName), 1)) : _createCommentVNode("", true)]), Object.keys(levelInfo.value).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("span", _hoisted_24, _toDisplayString((_levelInfo$value3 = levelInfo.value) === null || _levelInfo$value3 === void 0 || (_levelInfo$value3 = _levelInfo$value3.studentLevelInfo) === null || _levelInfo$value3 === void 0 ? void 0 : _levelInfo$value3.currentLevelName), 1), _createElementVNode("div", _hoisted_25, [_createVNode(_component_t_progress, {
        percentage: ((_levelInfo$value4 = levelInfo.value) === null || _levelInfo$value4 === void 0 || (_levelInfo$value4 = _levelInfo$value4.userPointInfo) === null || _levelInfo$value4 === void 0 ? void 0 : _levelInfo$value4.studentTotalPoint) / ((_levelInfo$value5 = levelInfo.value) === null || _levelInfo$value5 === void 0 || (_levelInfo$value5 = _levelInfo$value5.studentLevelInfo) === null || _levelInfo$value5 === void 0 ? void 0 : _levelInfo$value5.nextLevelThreshold) * 100,
        trackColor: "#FCEFDF",
        color: "#FFA63A",
        label: false,
        size: "small"
      }, null, 8, ["percentage"])]), _createElementVNode("span", _hoisted_26, _toDisplayString("LV".concat((_levelInfo$value6 = levelInfo.value) === null || _levelInfo$value6 === void 0 || (_levelInfo$value6 = _levelInfo$value6.studentLevelInfo) === null || _levelInfo$value6 === void 0 ? void 0 : _levelInfo$value6.currentLevelNum)), 1), _createElementVNode("span", _hoisted_27, _toDisplayString((_levelInfo$value7 = levelInfo.value) === null || _levelInfo$value7 === void 0 || (_levelInfo$value7 = _levelInfo$value7.userPointInfo) === null || _levelInfo$value7 === void 0 ? void 0 : _levelInfo$value7.studentTotalPoint) + "/" + _toDisplayString((_levelInfo$value8 = levelInfo.value) === null || _levelInfo$value8 === void 0 || (_levelInfo$value8 = _levelInfo$value8.studentLevelInfo) === null || _levelInfo$value8 === void 0 ? void 0 : _levelInfo$value8.nextLevelThreshold), 1)])) : _createCommentVNode("", true)])]), (_infoData$value$class = infoData.value.classCommitteeNames) !== null && _infoData$value$class !== void 0 && _infoData$value$class.length && (_infoData$value$certi = infoData.value.certificateNames) !== null && _infoData$value$certi !== void 0 && _infoData$value$certi.length ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_withDirectives(_createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_infoData$value$certi2 = infoData.value.certificateNames) === null || _infoData$value$certi2 === void 0 ? void 0 : _infoData$value$certi2.slice(0, 3), function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "item-honor"
        }, _toDisplayString(item), 1);
      }), 128))], 512), [[_vShow, (_infoData$value$certi3 = infoData.value.certificateNames) === null || _infoData$value$certi3 === void 0 ? void 0 : _infoData$value$certi3.length]]), _withDirectives(_createElementVNode("div", _hoisted_30, null, 512), [[_vShow, ((_infoData$value$class2 = infoData.value.classCommitteeNames) === null || _infoData$value$class2 === void 0 ? void 0 : _infoData$value$class2.length) && ((_infoData$value$certi4 = infoData.value.certificateNames) === null || _infoData$value$certi4 === void 0 ? void 0 : _infoData$value$certi4.length)]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_infoData$value$class3 = infoData.value.classCommitteeNames) === null || _infoData$value$class3 === void 0 ? void 0 : _infoData$value$class3.slice(0, 5), function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "item-job"
        }, _toDisplayString(item), 1);
      }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: "right-introduce",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return goUserInfo(!infoData.value.personalProfile);
        })
      }, _toDisplayString(infoData.value.personalProfile || (visitorType.value === 1 ? '点击此处去完善个人简介' : '')), 1)])], 4), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs, function (tab, index) {
        return _openBlock(), _createElementBlock("div", {
          key: tab.icon,
          class: _normalizeClass({
            'item-tab': true,
            'active-tab': activeTab.value === index
          }),
          onClick: function onClick($event) {
            return changeActiveTab(index);
          }
        }, [_createVNode(_component_svg_icon, {
          name: tab.icon,
          size: 20
        }, null, 8, ["name"]), _createElementVNode("span", _hoisted_34, _toDisplayString(tab.name), 1)], 10, _hoisted_33);
      }), 128))])]), _createElementVNode("div", _hoisted_35, [curUserId.value ? (_openBlock(), _createBlock(_resolveDynamicComponent(tabs[activeTab.value].component), {
        key: 0,
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return activeTab.value = $event;
        }),
        curUserId: curUserId.value,
        visitorType: visitorType.value,
        showScope: infoData.value.radius,
        spaceInfo: infoData.value,
        "avatar-img": infoData.value.avatar,
        onChangeId: changeId
      }, null, 40, ["modelValue", "curUserId", "visitorType", "showScope", "spaceInfo", "avatar-img"])) : _createCommentVNode("", true)])]), _createVNode(BgImageDialog, {
        visible: showBgImageDialog.value,
        "onUpdate:visible": _cache[6] || (_cache[6] = function ($event) {
          return showBgImageDialog.value = $event;
        }),
        "store-data": _unref(userInfo),
        "default-index": infoData.value.backgroundImage,
        type: 0,
        onChange: getBaseInfo
      }, null, 8, ["visible", "store-data", "default-index"])]);
    };
  }
};